import { useState, useEffect } from "react";

import styles from "../Main.module.css";
import LicenseTag from "../../../components/LicenseTag";

import {
  Button,
  Select,
  Input,
  Text,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  useToast,
  ModalFooter,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import {
  useDisclosure,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import {
  IconButton,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
} from "@chakra-ui/react";
import {
  AddIcon,
  CheckIcon,
  CloseIcon,
  DeleteIcon,
  EditIcon,
} from "@chakra-ui/icons";

import solutionHeaders from "../utils/data/solutionHeaders.json";
import pileCapTypes from "../utils/data/pileCapTypes.json";

import {
  columnGroupRegister,
  columnGroupEdit,
  columnGroupRemove,
} from "../utils/services/solutions";

import {
  columnRegister,
  columnEdit,
  columnRemove,
} from "../utils/services/solutions";

import {
  solutionRegister,
  solutionEdit,
  solutionRemove,
  pileLengthCalculate,
} from "../utils/services/solutions";

import { foundationRemove } from "../utils/services/solutions";

import solutionMemorialExcelBuilder from "../utils/templates/solutionMemorialExcelBuilder";

import GraphsCompare from "./components/solution/GraphsCompare";
import ColumnManager from "./components/solution/ColumnManager";
import FoundationManager from "./components/solution/FoundationManager";

function Structure({
  userInputs,
  projectInputs,
  investigationInputs,
  geotechnicsInputs,
  projectData,
  updateProjectData,
  foundationClass,
  columnGroupInputs,
  updateColumnGroupInputs,
  columnInputs,
  setColumnInputs,
  updateColumnInputs,
  updateColumnInputsCombs,
  solutionInputs,
  updateSolutionInputs,
}) {
  const toast = useToast();

  // COLUMNS MANAGER
  const [formColumnGroup, setFormColumnGroup] = useState(false);
  const [formColumn, setFormColumn] = useState(false);

  function onColumnGroupAction(action) {
    const options = {
      register: async () => {
        if (columnGroupInputs["name_input"] === "") {
          toast({
            title: "Preencha o nome do setor",
            status: "warning",
            isClosable: true,
          });
        } else if (
          Object.keys(projectData["columns"]).some(
            (columnGroup) => columnGroup === columnGroupInputs["name_input"]
          )
        ) {
          toast({
            title:
              "Um setor com esse nome já existe. Escolha um nome diferente",
            status: "error",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Cadastrando setor...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await columnGroupRegister([
              userInputs,
              projectData["name"],
              columnGroupInputs,
            ]);
            //Optimistic Update
            const updatedColumnsData = projectData["columns"];
            updatedColumnsData[columnGroupInputs["name_input"]] = [];
            updateProjectData("columns", updatedColumnsData);
            setFormColumnGroup("");
            updateColumnGroupInputs(
              "selected_name",
              columnGroupInputs["name_input"]
            );
            updateColumnGroupInputs("name_input", "");
            toast({
              title: "Setor cadastrado com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao cadastrar setor, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
      edit: async () => {
        if (columnGroupInputs["name_input"] === "") {
          toast({
            title: "Preencha o nome do setor",
            status: "warning",
            isClosable: true,
          });
        } else if (
          Object.keys(projectData["columns"]).some(
            (columnGroup) => columnGroup === columnGroupInputs["name_input"]
          )
        ) {
          toast({
            title:
              "Um setor com esse nome já existe. Escolha um nome diferente",
            status: "error",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Editando setor...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await columnGroupEdit([
              userInputs,
              projectData["name"],
              columnGroupInputs,
            ]);
            //Optimistic Update
            //  Foundations
            const updatedSolutionsData = projectData["solutions"];
            Object.entries(updatedSolutionsData).map(
              ([solutionName, solution]) => {
                solution.map((foundation, i) => {
                  if (
                    foundation["column_group"] ===
                    columnGroupInputs["selected_name"]
                  ) {
                    updatedSolutionsData[solutionName][i]["column_group"] =
                      columnGroupInputs["name_input"];
                  }
                });
              }
            );
            updateProjectData("solutions", updatedSolutionsData);
            //  Columns
            const updatedColumnsData = projectData["columns"];
            updatedColumnsData[columnGroupInputs["name_input"]] =
              projectData["columns"][columnGroupInputs["selected_name"]];
            delete updatedColumnsData[columnGroupInputs["selected_name"]];
            updateProjectData("columns", updatedColumnsData);
            setFormColumnGroup("");
            updateColumnGroupInputs(
              "selected_name",
              columnGroupInputs["name_input"]
            );
            updateColumnGroupInputs("name_input", "");
            toast({
              title: "Setor editada com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao editar setor, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
      remove: async () => {
        if (Object.keys(projectData["columns"]).length === 1) {
          toast({
            title:
              "Essa é o único setor do projeto, para removê-lo, apague o projeto",
            status: "error",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Removendo setor...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await columnGroupRemove([
              userInputs,
              projectData["name"],
              columnGroupInputs,
            ]);
            //Optimistic Update
            const updatedColumnsData = projectData["columns"];
            delete updatedColumnsData[columnGroupInputs["selected_name"]];
            updateProjectData("columns", updatedColumnsData);
            const updatedSolutionsData = { ...projectData["solutions"] };
            Object.entries(updatedSolutionsData).map(
              ([solution, foundations]) => {
                foundations.map((foundation, i) => {
                  if (
                    foundation["column_group"] ===
                    columnGroupInputs["selected_name"]
                  ) {
                    updatedSolutionsData[solution].splice(i, 1);
                  }
                });
              }
            );
            updateProjectData("solutions", updatedSolutionsData);
            setFormColumnGroup("");
            updateColumnGroupInputs(
              "selected_name",
              Object.keys(projectData["columns"])[0]
            );
            toast({
              title: "Setor removido com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao remover setor, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
    };
    for (const [key, value] of Object.entries(options)) {
      if (action === key) {
        value();
      }
    }
  }

  function onColumnAction(action) {
    const options = {
      register: async () => {
        if (columnInputs["name"] === "") {
          toast({
            title: "Preencha todos os campos do pilar",
            status: "warning",
            isClosable: true,
          });
        } else if (
          projectData["columns"][columnGroupInputs["selected_name"]].some(
            (column) => column["name"] === "P" + columnInputs["name"]
          )
        ) {
          toast({
            title:
              "Um pilar com esse nome já existe. Escolha um nome diferente",
            status: "error",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Cadastrando pilar...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await columnRegister([
              userInputs,
              projectData["name"],
              columnGroupInputs["selected_name"],
              columnInputs,
            ]);
            const updatedColumnsData = projectData["columns"];
            updatedColumnsData[columnGroupInputs["selected_name"]].push({
              name: "P" + columnInputs["name"],
              combs: columnInputs["combs"],
            });
            updateProjectData("columns", updatedColumnsData);
            setColumnInputs({
              selected_name: "",
              name: "",
              combs: {
                fz_max: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
                fz_min: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
                mx_max: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
                my_max: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
              },
            });
            toast({
              title: "Pilar cadastrado com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao cadastrar pilar, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
      edit: async () => {
        if (columnInputs["selected_name"] === "") {
          toast({
            title: "Para executar essa função, selecione um pilar",
            status: "warning",
            isClosable: true,
          });
        } else if (columnInputs["name"] === "") {
          toast({
            title: "Preencha todos os campos do pilar",
            status: "warning",
            isClosable: true,
          });
        } else if (
          "P" + columnInputs["name"] !== columnInputs["selected_name"] &&
          projectData["columns"][columnGroupInputs["selected_name"]].some(
            (column) => column["name"] === "P" + columnInputs["name"]
          )
        ) {
          toast({
            title:
              "Um pilar com esse nome já existe. Escolha um nome diferente",
            status: "error",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Editando pilar...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await columnEdit([
              userInputs,
              projectData["name"],
              columnGroupInputs["selected_name"],
              columnInputs,
            ]);
            //Optimistic Update
            //  Foundations
            const updatedSolutionsData = projectData["solutions"];
            Object.entries(updatedSolutionsData).map(
              ([solutionName, solution]) => {
                solution.map((foundation, i) => {
                  if (foundation["column"] === columnInputs["selected_name"]) {
                    updatedSolutionsData[solutionName][i]["column"] =
                      "P" + columnInputs["name"];
                  }
                });
              }
            );
            updateProjectData("solutions", updatedSolutionsData);
            //  Columns
            const updatedColumnsData = projectData["columns"];
            updatedColumnsData[columnGroupInputs["selected_name"]].map(
              (column, i) => {
                if (columnInputs["selected_name"] === column["name"]) {
                  updatedColumnsData[columnGroupInputs["selected_name"]][i] = {
                    name: "P" + columnInputs["name"],
                    combs: columnInputs["combs"],
                  };
                }
              }
            );
            updateProjectData("columns", updatedColumnsData);
            setColumnInputs({
              selected_name: "",
              name: "",
              combs: {
                fz_max: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
                fz_min: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
                mx_max: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
                my_max: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
              },
            });
            toast({
              title: "Pilar editado com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao editar pilar, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
      remove: async () => {
        if (columnInputs["selected_name"] === "") {
          toast({
            title: "Para executar essa função, selecione um pilar",
            status: "warning",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Removendo pilar...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await columnRemove([
              userInputs,
              projectData["name"],
              columnGroupInputs["selected_name"],
              columnInputs,
            ]);
            const updatedColumnsData = projectData["columns"];
            updatedColumnsData[columnGroupInputs["selected_name"]].map(
              (column, i) => {
                if (columnInputs["selected_name"] === column["name"]) {
                  updatedColumnsData[columnGroupInputs["selected_name"]].splice(
                    i,
                    1
                  );
                }
              }
            );
            updateProjectData("columns", updatedColumnsData);
            updateColumnInputs("selected_name", "");
            toast({
              title: "Pilar removido com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao remover pilar, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
    };
    for (const [key, value] of Object.entries(options)) {
      if (action === key) {
        value();
      }
    }
  }

  // SOLUTIONS MANAGER
  const [formFoundation, setFormFoundation] = useState("");
  const [formSolution, setFormSolution] = useState("");

  function onSolutionAction(action) {
    const options = {
      register: async () => {
        if (solutionInputs["name_input"] === "") {
          toast({
            title: "Preencha o nome da solução",
            status: "warning",
            isClosable: true,
          });
        } else if (
          Object.keys(projectData["solutions"]).some(
            (solution) => solution === solutionInputs["name_input"]
          )
        ) {
          toast({
            title:
              "Uma solução com esse nome já existe. Escolha um nome diferente",
            status: "error",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Cadastrando solução...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await solutionRegister([
              userInputs,
              projectData["name"],
              solutionInputs,
            ]);
            //Optimistic Update
            const updatedSolutionsData = projectData["solutions"];
            updatedSolutionsData[solutionInputs["name_input"]] = [];
            updateProjectData("solutions", updatedSolutionsData);
            setFormSolution("");
            updateSolutionInputs("selected_name", solutionInputs["name_input"]);
            updateSolutionInputs("name_input", "");
            toast({
              title: "Solução cadastrada com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao cadastrar solução, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
      edit: async () => {
        if (solutionInputs["name_input"] === "") {
          toast({
            title: "Preencha o nome da solução",
            status: "warning",
            isClosable: true,
          });
        } else if (
          Object.keys(projectData["solutions"]).some(
            (solution) => solution === solutionInputs["name_input"]
          )
        ) {
          toast({
            title:
              "Uma solução com esse nome já existe. Escolha um nome diferente",
            status: "error",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Editando solução...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await solutionEdit([
              userInputs,
              projectData["name"],
              solutionInputs,
            ]);
            //Optimistic Update
            const updatedSolutionsData = projectData["solutions"];
            updatedSolutionsData[solutionInputs["name_input"]] =
              projectData["solutions"][solutionInputs["selected_name"]];
            delete updatedSolutionsData[solutionInputs["selected_name"]];
            updateProjectData("solutions", updatedSolutionsData);
            setFormSolution("");
            updateSolutionInputs("selected_name", solutionInputs["name_input"]);
            updateSolutionInputs("name_input", "");
            toast({
              title: "Solução editada com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao editar solução, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
      remove: async () => {
        if (Object.keys(projectData["solutions"]).length === 1) {
          toast({
            title:
              "Essa é a única solução do projeto, para removê-la, apague o projeto",
            status: "error",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Removendo solução...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await solutionRemove([
              userInputs,
              projectData["name"],
              solutionInputs,
            ]);
            //Optimistic Update
            const updatedSolutionsData = projectData["solutions"];
            delete updatedSolutionsData[solutionInputs["selected_name"]];
            updateProjectData("solutions", updatedSolutionsData);
            setFormSolution("");
            updateSolutionInputs(
              "selected_name",
              Object.keys(projectData["solutions"])[0]
            );
            toast({
              title: "Solução removida com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao remover solução, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
    };
    for (const [key, value] of Object.entries(options)) {
      if (action === key) {
        value();
      }
    }
  }

  // FOUNDATION SOLUTION
  const [foundationInputs, setFoundationInputs] = useState({
    selected_name: "",
    name: "",
    l: 90,
    n: "1",
    rotate: "0",
    z: 0,
    weight: 0,
    rc: 0,
    rc_pile: "",
    rc_comb: "",
    rt: 0,
    rt_pile: "",
    rt_comb: "",
    clength: 0,
    tlength: 0,
    length: 1,
    rc_adm:
      projectData["investigations"][investigationInputs["selected_name"]][0][
        "pa"
      ],
    rt_adm:
      (-projectData["investigations"][investigationInputs["selected_name"]][0][
        "rl_accumulated"
      ] *
        0.7) /
      2,
  });

  const [pileInputs, setPileInputs] = useState({
    E1: {
      ex: 0,
      ey: 0,
      x: 0,
      y: 0,
      combs: {
        fz_max: { fz: 0, mx: 0, my: 0 },
        fz_min: { fz: 0, mx: 0, my: 0 },
        mx_max: { fz: 0, mx: 0, my: 0 },
        my_max: { fz: 0, mx: 0, my: 0 },
      },
    },
  });

  function updateFoundationInputs(key, value) {
    setFoundationInputs((prevInputs) => ({ ...prevInputs, [key]: value }));
  }

  function updatePileInputs(mainKey, subKey, value) {
    if (subKey === "combs") {
      setPileInputs((prevInputs) => ({
        ...prevInputs,
        [mainKey]: {
          ...prevInputs[mainKey],
          [subKey]: value,
        },
      }));
    } else {
      if (
        value === "" ||
        value === "-" ||
        value.endsWith(".") ||
        value.endsWith(".0") ||
        value.endsWith("-0")
      ) {
        setPileInputs((prevInputs) => ({
          ...prevInputs,
          [mainKey]: {
            ...prevInputs[mainKey],
            [subKey]: value,
          },
        }));
      } else {
        setPileInputs((prevInputs) => ({
          ...prevInputs,
          [mainKey]: {
            ...prevInputs[mainKey],
            [subKey]: Number(value),
          },
        }));
      }
    }
  }

  async function onFoundationRemove(selectedName) {
    if (selectedName !== "") {
      const toastId = toast({
        title: "Removendo fundação...",
        description: "Aguarde enquanto os dados são processados.",
        status: "loading",
        duration: null,
      });

      try {
        await foundationRemove([
          userInputs,
          projectData["name"],
          columnGroupInputs["selected_name"],
          solutionInputs,
          selectedName,
        ]);
        //Optimistic Update
        const updatedSolutionsData = projectData["solutions"];
        const updatedFoundationsData = [
          ...projectData["solutions"][solutionInputs["selected_name"]],
        ];
        updatedFoundationsData.map((foundation, i) => {
          if (selectedName === foundation["name"])
            updatedFoundationsData.splice(i, 1);
        });
        updatedSolutionsData[solutionInputs["selected_name"]] =
          updatedFoundationsData;
        updateProjectData("solutions", updatedSolutionsData);
        updateFoundationInputs("selected_name", "");
        toast({
          title: "Fundação removida com sucesso",
          status: "success",
          isClosable: true,
        });
      } catch (error) {
        toast({
          title: "Erro ao remover fundação, tente novamente mais tarde",
          status: "error",
          isClosable: true,
        });
      } finally {
        toast.close(toastId);
      }
    }
  }

  // EXPORT FOUNDATIONS
  const [reportInputs, setReportInputs] = useState("Resumo de Fundações");

  function onExport() {
    if (
      projectData["solutions"][solutionInputs["selected_name"]].length === 0
    ) {
      toast({
        title: "Cadastre ao menos uma fundação para exportar um resumo",
        status: "warning",
        isClosable: true,
      });
    } else {
      const toastId = toast({
        title: "Exportando resumo...",
        status: "loading",
        duration: null,
      });
      if (reportInputs === "Resumo de Fundações") {
        solutionMemorialExcelBuilder(projectData, solutionInputs)
          .then((response) => {
            toast({
              title: "Resumo gerado com sucesso",
              status: "success",
              isClosable: true,
            });
          })
          .catch((error) => {
            toast({
              title: "Erro ao gerar resumo",
              description: "Por favor, tente novamente mais tarde.",
              status: "error",
              isClosable: true,
            });
          })
          .finally(() => {
            toast.close(toastId);
          });
      }
    }
  }

  return (
    <>
      <div className={styles.mainStructure}>
        <div className={styles.sectionGeotechnics}>
          <div className={styles.sectionGeotechnicsHeader}>
            <Text>
              Método: <strong>{geotechnicsInputs["method"]}</strong>
            </Text>
            <Text>
              Diâmetro = <strong>{geotechnicsInputs["dimension_1"]} cm</strong>
            </Text>
          </div>
          <div className={styles.sectionGeotechnicsSection}>
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Comprimento</Th>
                  <Th>C. Adm (tf)</Th>
                  {/* <Th>(+) C. Adm (kn)</Th> */}
                </Tr>
              </Thead>
              <Tbody>
                {projectData["investigations"][
                  investigationInputs["selected_name"]
                ].map((camada, i) =>
                  camada["pa"] !== "" && camada["pa"] !== "-" ? (
                    <Tr
                      aria-selected={
                        Number(foundationInputs["length"]) ===
                        i + 1 + Number(geotechnicsInputs["dimension_3"])
                          ? "true"
                          : "false"
                      }
                      key={"row-" + i}
                    >
                      <Td>
                        {camada["elevation"] +
                          Number(geotechnicsInputs["dimension_3"])}
                      </Td>
                      <Td>{camada["pa"]}</Td>
                    </Tr>
                  ) : null
                )}
              </Tbody>
            </Table>
          </div>
          <div className={styles.sectionGeotechnicsFooter}>
            <Text>
              Sondagem: <strong>{investigationInputs["selected_name"]}</strong>
            </Text>
          </div>
        </div>
        <div className={styles.sectionStructure}>
          <div className={styles.structureHeader}>
            <div className={styles.structureSectionRow}>
              <div>ESFORÇOS:</div>
            </div>
            <div className={styles.structureSectionRow}>
              <Button
                name="manage"
                size="sm"
                onClick={() => {
                  setColumnInputs({
                    selected_name: "",
                    name: "",
                    combs: {
                      fz_max: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
                      fz_min: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
                      mx_max: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
                      my_max: { fz: 0, fx: 0, fy: 0, mx: 0, my: 0 },
                    },
                  });
                  setFormColumn(true);
                }}
              >
                Gerenciar
              </Button>
              <div className={styles.structureSectionElement}>
                <Text fontSize="md">Setor: </Text>
                <Select
                  name="column_group"
                  onChange={(ev) => {
                    updateColumnGroupInputs("selected_name", ev.target.value);
                    updateColumnInputs(
                      "name",
                      Object.values(projectData["columns"][ev.target.value])[0][
                        "name"
                      ]
                    );
                    updateColumnInputs(
                      "combs",
                      Object.values(projectData["columns"][ev.target.value])[0][
                        "combs"
                      ]
                    );
                  }}
                  variant="outline"
                  w="200px"
                  size="xs"
                  fontSize="md"
                  value={columnGroupInputs["selected_name"]}
                >
                  {Object.keys(projectData["columns"])
                    .sort((a, b) => a.localeCompare(b))
                    .map((columnGroup, i) => (
                      <option key={i} value={columnGroup}>
                        {" "}
                        {columnGroup}{" "}
                      </option>
                    ))}
                </Select>
              </div>
              <div className={styles.structureSectionElement}>
                <Text fontSize="md">Pilar: </Text>
                <Select
                  name="column"
                  onChange={(ev) => {
                    updateColumnInputs("selected_name", ev.target.value);
                    projectData["columns"][
                      columnGroupInputs["selected_name"]
                    ].map((column, i) => {
                      if (column["name"] === ev.target.value) {
                        updateColumnInputs("combs", column["combs"]);
                      }
                    });
                  }}
                  variant="outline"
                  w="150px"
                  size="xs"
                  fontSize="md"
                  value={columnInputs["selected_name"]}
                >
                  {projectData["columns"][columnGroupInputs["selected_name"]]
                    .sort((a, b) => {
                      const numA = a.name.match(/\d+/);
                      const numB = b.name.match(/\d+/);
                      return numA - numB;
                    })
                    .map((column, i) => (
                      <option key={i} value={column["name"]}>
                        {" "}
                        {column["name"]}{" "}
                      </option>
                    ))}
                </Select>
              </div>
            </div>
            <div className={styles.structureSectionRow}>
              <Text fontSize="md" fontWeight="bold">
                Fz= {columnInputs["combs"]["fz_max"]["fz"]} tf
              </Text>
              <Text fontSize="md" fontWeight="bold">
                Fx= {columnInputs["combs"]["fz_max"]["fx"]} tf
              </Text>
              <Text fontSize="md" fontWeight="bold">
                Fy= {columnInputs["combs"]["fz_max"]["fy"]} tf
              </Text>
              <Text fontSize="md" fontWeight="bold">
                Mx= {columnInputs["combs"]["fz_max"]["mx"]} tf.m
              </Text>
              <Text fontSize="md" fontWeight="bold">
                My= {columnInputs["combs"]["fz_max"]["my"]} tf.m
              </Text>
            </div>
            <div className={styles.structureSectionRow}>
              <div>FUNDAÇÃO:</div>
            </div>
            <div className={styles.structureSectionRow}>
              <Button
                name="foundation_manager"
                size="sm"
                onClick={() => {
                  setFormFoundation("register");
                }}
              >
                Lançar Fundação
              </Button>
            </div>
          </div>
          <div className={styles.structureSection}>
            <Table variant="simple">
              <Thead>
                <Tr key="solution-header">
                  {solutionHeaders["foundations"]["headers"].map(
                    (header, i) => (
                      <Th key={"th" + i}>{header}</Th>
                    )
                  )}
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {projectData["solutions"][solutionInputs["selected_name"]] &&
                projectData["solutions"][solutionInputs["selected_name"]]
                  .length !== 0 &&
                projectData["solutions"][solutionInputs["selected_name"]].some(
                  (foundation) =>
                    foundation["column_group"] ===
                    columnGroupInputs["selected_name"]
                ) ? (
                  projectData["solutions"][solutionInputs["selected_name"]]
                    .filter(
                      (foundation) =>
                        foundation["column_group"] ===
                        columnGroupInputs["selected_name"]
                    )
                    .sort((a, b) => {
                      const numA = a.name.match(/\d+/);
                      const numB = b.name.match(/\d+/);
                      return numA - numB;
                    })
                    .map((foundation, i) => (
                      <Tr
                        sx={{
                          _hover: {
                            td: {
                              color: "var(--text-color) !important",
                            },
                          },
                        }}
                        key={"row-" + i}
                      >
                        {solutionHeaders["foundations"]["values"].map(
                          (h, _i) => {
                            return h === "name" || h === "investigation" ? (
                              <Td key={"col-" + _i}>{foundation[h]}</Td>
                            ) : h === "rc" || h === "rt" ? (
                              <Td key={"col-" + _i}>
                                {foundation["parameters"][h].toFixed(2)}
                              </Td>
                            ) : h === "rc_adm" ? (
                              <Td key={"col-" + _i}>
                                <Text
                                  // as="strong"
                                  color={
                                    foundation["parameters"][h] <
                                    foundation["parameters"]["rc"]
                                      ? "red.500"
                                      : "green.500"
                                  }
                                >
                                  {foundation["parameters"][h].toFixed(2)}
                                </Text>
                              </Td>
                            ) : h === "rt_adm" ? (
                              <Td key={"col-" + _i}>
                                <Text
                                  // as="strong"
                                  color={
                                    foundation["parameters"][h] >
                                    foundation["parameters"]["rt"]
                                      ? "red.500"
                                      : "green.500"
                                  }
                                >
                                  {foundation["parameters"][h].toFixed(2)}
                                </Text>
                              </Td>
                            ) : (
                              <Td key={"col-" + _i}>
                                {foundation["parameters"][h]}
                              </Td>
                            );
                          }
                        )}
                        <Td>
                          <IconButton
                            variant="icon"
                            icon={<EditIcon />}
                            onClick={() => {
                              updateColumnInputs(
                                "selected_name",
                                foundation["column"]
                              );
                              let columnExists = false;
                              projectData["columns"][
                                columnGroupInputs["selected_name"]
                              ].map((column, i) => {
                                if (column["name"] === foundation["column"]) {
                                  columnExists = true;
                                  updateColumnInputs("combs", column["combs"]);
                                }
                              });
                              if (!columnExists) {
                                updateColumnInputs("selected_name", "N/A");
                              }
                              updateFoundationInputs(
                                "selected_name",
                                foundation["name"].replace("B", "")
                              );
                              updateFoundationInputs(
                                "name",
                                foundation["name"].replace("B", "")
                              );
                              updateFoundationInputs(
                                "l",
                                foundation["parameters"]["l"]
                              );
                              updateFoundationInputs(
                                "n",
                                foundation["parameters"]["quantity"]
                              );
                              updateFoundationInputs(
                                "rotate",
                                foundation["parameters"]["rotate"]
                              );
                              updateFoundationInputs(
                                "z",
                                foundation["parameters"]["z"]
                              );
                              updateFoundationInputs(
                                "weight",
                                foundation["parameters"]["weight"]
                              );
                              updateFoundationInputs(
                                "rc",
                                foundation["parameters"]["rc"]
                              );
                              updateFoundationInputs(
                                "rt",
                                foundation["parameters"]["rt"]
                              );
                              updateFoundationInputs(
                                "length",
                                foundation["parameters"]["length"]
                              );
                              const totalLength = projectData["investigations"][
                                investigationInputs["selected_name"]
                              ].filter(
                                (camada) =>
                                  camada["pa"] !== "" && camada["pa"] !== "-"
                              ).length;
                              if (
                                foundation["parameters"]["length"] > totalLength
                              ) {
                                updateFoundationInputs("length", "N/A");
                              }
                              updateFoundationInputs(
                                "rc_adm",
                                projectData["investigations"][
                                  investigationInputs["selected_name"]
                                ][foundation["parameters"]["length"] - 1]["pa"]
                              );
                              updateFoundationInputs(
                                "rt_adm",
                                (-projectData["investigations"][
                                  investigationInputs["selected_name"]
                                ][foundation["parameters"]["length"] - 1][
                                  "rl_accumulated"
                                ] *
                                  0.7) /
                                  2
                              );
                              setPileInputs(foundation["combs"]);
                              setFormFoundation("edit");
                            }}
                          />
                          <IconButton
                            variant="icon"
                            icon={<DeleteIcon />}
                            onClick={() => {
                              onFoundationRemove(foundation["name"]);
                            }}
                          />
                        </Td>
                      </Tr>
                    ))
                ) : (
                  <Tr
                    key={"row-0"}
                    sx={{
                      _hover: {
                        td: {
                          color: "var(--text-color) !important",
                        },
                      },
                    }}
                  >
                    <Td>-</Td>
                    <Td>-</Td>
                    <Td>-</Td>
                    <Td>-</Td>
                    <Td>-</Td>
                    <Td>-</Td>
                    <Td>-</Td>
                    <Td>-</Td>
                    <Td>-</Td>
                    <Td>-</Td>
                    <Td>-</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </div>
          <div className={styles.structureFooter}>
            <div className={styles.structureSectionElement}>
              <Select
                name="selected_name"
                onChange={(ev) =>
                  updateSolutionInputs("selected_name", ev.target.value)
                }
                variant="outline"
                w="150px"
                size="sm"
                fontSize="md"
                value={solutionInputs["selected_name"]}
              >
                {Object.keys(projectData["solutions"])
                  .sort((a, b) => a.localeCompare(b))
                  .map((solutionName, i) => (
                    <option key={i} value={solutionName}>
                      {" "}
                      {solutionName}{" "}
                    </option>
                  ))}
              </Select>
              <Popover
                placement="bottom"
                isOpen={formSolution === "register"}
                onOpen={() => setFormSolution("register")}
                onClose={() => setFormSolution("")}
              >
                <PopoverTrigger>
                  {userInputs["licenses"]["fundars"]["plan"] === "pro" ||
                  userInputs["licenses"]["fundars"]["plan"] === "premium" ||
                  userInputs["licenses"]["fundars"]["plan"] === "tester" ? (
                    <IconButton
                      variant="icon"
                      icon={
                        <Tooltip
                          hasArrow
                          label="Criar"
                          bg="gray"
                          color="black"
                          fontSize="md"
                          isDisabled={
                            userInputs["licenses"]["fundars"]["plan"] !==
                              "pro" &&
                            userInputs["licenses"]["fundars"]["plan"] !==
                              "premium" &&
                            userInputs["licenses"]["fundars"]["plan"] !==
                              "tester"
                          }
                        >
                          <AddIcon />
                        </Tooltip>
                      }
                      isDisabled={
                        userInputs["licenses"]["fundars"]["plan"] !== "pro" &&
                        userInputs["licenses"]["fundars"]["plan"] !==
                          "premium" &&
                        userInputs["licenses"]["fundars"]["plan"] !== "tester"
                      }
                    />
                  ) : (
                    <Tooltip
                      placement="top"
                      isDisabled={
                        userInputs["licenses"]["fundars"]["plan"] === "pro" ||
                        userInputs["licenses"]["fundars"]["plan"] ===
                          "premium" ||
                        userInputs["licenses"]["fundars"]["plan"] === "tester"
                      }
                      label={
                        <span>
                          Para usar essa função habilite a licença{" "}
                          <LicenseTag plan="pro" /> ou uma superior
                        </span>
                      }
                    >
                      <IconButton
                        variant="icon"
                        icon={<AddIcon />}
                        isDisabled={
                          userInputs["licenses"]["fundars"]["plan"] !== "pro" &&
                          userInputs["licenses"]["fundars"]["plan"] !==
                            "premium" &&
                          userInputs["licenses"]["fundars"]["plan"] !== "tester"
                        }
                      />
                    </Tooltip>
                  )}
                </PopoverTrigger>
                <PopoverContent flexDirection={"row"}>
                  <PopoverArrow backgroundColor={"black"} />
                  <Input
                    name="name_input"
                    type="text"
                    placeholder="Digite o nome da solução"
                    onChange={(ev) =>
                      updateSolutionInputs("name_input", ev.target.value)
                    }
                    value={solutionInputs["name_input"]}
                  />
                  <IconButton
                    variant="icon"
                    icon={<CheckIcon />}
                    onClick={() => onSolutionAction(formSolution)}
                  />
                  <IconButton
                    variant="icon"
                    icon={<CloseIcon />}
                    onClick={() => {
                      setFormSolution("");
                      updateSolutionInputs("name_input", "");
                    }}
                  />
                </PopoverContent>
              </Popover>
              <Popover
                placement="bottom"
                isOpen={formSolution === "edit"}
                onOpen={() => setFormSolution("edit")}
                onClose={() => setFormSolution("")}
              >
                <PopoverTrigger>
                  <IconButton
                    variant="icon"
                    icon={
                      <Tooltip
                        hasArrow
                        label="Editar"
                        bg="gray"
                        color="black"
                        fontSize="md"
                      >
                        <EditIcon />
                      </Tooltip>
                    }
                  />
                </PopoverTrigger>
                <PopoverContent flexDirection={"row"}>
                  <PopoverArrow backgroundColor={"black"} />
                  <Input
                    name="name_input"
                    type="text"
                    placeholder="Digite o nome da solução"
                    onChange={(ev) =>
                      updateSolutionInputs("name_input", ev.target.value)
                    }
                    value={solutionInputs["name_input"]}
                  />
                  <IconButton
                    variant="icon"
                    icon={<CheckIcon />}
                    onClick={() => onSolutionAction(formSolution)}
                  />
                  <IconButton
                    variant="icon"
                    icon={<CloseIcon />}
                    onClick={() => {
                      setFormSolution("");
                      updateSolutionInputs("name_input", "");
                    }}
                  />
                </PopoverContent>
              </Popover>

              <IconButton
                variant="icon"
                icon={
                  <Tooltip
                    hasArrow
                    label="Remover"
                    bg="gray"
                    color="black"
                    fontSize="md"
                  >
                    <DeleteIcon />
                  </Tooltip>
                }
                onClick={() => setFormSolution("remove")}
              />
              <Tooltip
                placement="top"
                isDisabled={
                  userInputs["licenses"]["fundars"]["plan"] === "premium" ||
                  userInputs["licenses"]["fundars"]["plan"] === "tester"
                }
                label={
                  <span>
                    Para usar essa função habilite a licença{" "}
                    <LicenseTag plan="premium" />
                  </span>
                }
              >
                <Button
                  size={"sm"}
                  isDisabled={
                    userInputs["licenses"]["fundars"]["plan"] !== "premium" &&
                    userInputs["licenses"]["fundars"]["plan"] !== "tester"
                  }
                  onClick={() => setFormSolution("compare")}
                >
                  Comparar
                </Button>
              </Tooltip>
            </div>
            <div className={styles.structureSectionElement}>
              <Button size={"sm"} onClick={() => setFormSolution("export")}>
                Exportar
              </Button>
            </div>
          </div>
        </div>
      </div>
      {formColumn && (
        <ColumnManager
          userInputs={userInputs}
          projectData={projectData}
          columnGroupInputs={columnGroupInputs}
          updateColumnGroupInputs={updateColumnGroupInputs}
          columnInputs={columnInputs}
          setColumnInputs={setColumnInputs}
          updateColumnInputs={updateColumnInputs}
          updateColumnInputsCombs={updateColumnInputsCombs}
          formColumnGroup={formColumnGroup}
          setFormColumnGroup={setFormColumnGroup}
          formColumn={formColumn}
          setFormColumn={setFormColumn}
          onColumnGroupAction={onColumnGroupAction}
          onColumnAction={onColumnAction}
        />
      )}
      {(formFoundation === "register" || formFoundation === "edit") && (
        <FoundationManager
          userInputs={userInputs}
          investigationInputs={investigationInputs}
          geotechnicsInputs={geotechnicsInputs}
          columnGroupInputs={columnGroupInputs}
          columnInputs={columnInputs}
          updateColumnInputs={updateColumnInputs}
          solutionInputs={solutionInputs}
          projectData={projectData}
          updateProjectData={updateProjectData}
          foundationInputs={foundationInputs}
          setFoundationInputs={setFoundationInputs}
          pileInputs={pileInputs}
          setPileInputs={setPileInputs}
          updateFoundationInputs={updateFoundationInputs}
          updatePileInputs={updatePileInputs}
          formFoundation={formFoundation}
          setFormFoundation={setFormFoundation}
        />
      )}
      {formSolution === "remove" && solutionInputs["selected_name"] !== "" && (
        <Modal isCentered isOpen={formSolution !== ""}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Excluir {solutionInputs["selected_name"]}</ModalHeader>
            <ModalCloseButton
              onClick={() => {
                setFormSolution("");
              }}
            />
            <ModalBody>
              Deseja prosseguir? Essa ação não poderá ser desfeita
            </ModalBody>
            <ModalFooter>
              <Button
                variant="delete"
                onClick={() => onSolutionAction(formSolution)}
              >
                EXCLUIR
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
      {formSolution === "export" && (
        <Modal isCentered isOpen={formSolution !== ""} onClose={""}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Gerar Relatório</ModalHeader>
            <ModalCloseButton
              onClick={() => {
                setFormSolution("");
                setReportInputs("Memorial de Cálculo - Camada Única");
              }}
            />
            <ModalBody>
              <FormControl>
                <FormLabel>Tipo de Relatório à exportar:</FormLabel>
                <Select
                  value={reportInputs}
                  onChange={(ev) => setReportInputs(ev.target.value)}
                >
                  <optgroup label={"Excel"}>
                    <option key={"Resumo de Fundações"}>
                      {"Resumo de Fundações"}
                    </option>
                  </optgroup>
                </Select>
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Tooltip
                placement="bottom"
                isDisabled={
                  userInputs["licenses"]["fundars"]["plan"] !== "trial" &&
                  userInputs["licenses"]["fundars"]["plan"] !== "basic"
                }
                label={
                  <span>
                    Para usar essa função habilite a licença{" "}
                    <LicenseTag plan="pro" /> ou uma superior
                  </span>
                }
              >
                <Button
                  isDisabled={
                    userInputs["licenses"]["fundars"]["plan"] === "trial" ||
                    userInputs["licenses"]["fundars"]["plan"] === "basic"
                  }
                  onClick={onExport}
                >
                  BAIXAR
                </Button>
              </Tooltip>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
      {formSolution === "compare" && (
        <Modal isCentered isOpen={formSolution !== ""} onClose={""}>
          <ModalOverlay />
          <ModalContent w={"800px"}>
            <ModalHeader>Comparador de Soluções</ModalHeader>
            <ModalCloseButton
              onClick={() => {
                setFormSolution("");
              }}
            />
            <ModalBody>
              <GraphsCompare projectData={projectData} />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}

export default Structure;
